import { render } from "./changePassword.vue?vue&type=template&id=67a0c14c"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/grgnd.webweb.works/client/grapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__